import React, { createContext, useContext, useState } from 'react';

const CityContext = createContext();

export const useCity = () => {
  const context = useContext(CityContext);
  if (!context) {
    throw new Error('useCity must be used within a ContextApp');
  }
  return context;
};

export function ContextApp({ children }) {
  // Vérifier si on est dans un environnement de navigateur pour SSR
  const isBrowser = typeof window !== 'undefined';
  
  // Initialiser les états uniquement si nous sommes dans le navigateur
  const [selectedCity, setSelectedCity] = useState(isBrowser ? null : undefined);
  const [selectedDistrict, setSelectedDistrict] = useState(isBrowser ? null : undefined);
  const [selectedService, setSelectedService] = useState(isBrowser ? null : undefined);

  // Si ce n'est pas un navigateur (SSR), renvoyer un Provider avec des valeurs par défaut
  if (!isBrowser) {
    return (
      <CityContext.Provider value={{
        selectedCity: null,
        selectedDistrict: null,
        selectedService: null,
        handleSaveCity: () => {},
        handleSaveDistrict: () => {},
        handleSaveService: () => {},
        clearDistrict: () => {},
        clearCity: () => {}
      }}>
        {children}
      </CityContext.Provider>
    );
  }

  const handleSaveCity = (city) => {
    setSelectedCity(city);
  };
  
  const handleSaveDistrict = (district) => {
    setSelectedDistrict(district);
  };
  
  const handleSaveService = (service) => {
    setSelectedService(service);
  };
  
  const clearDistrict = () => {
    setSelectedDistrict(null);
  };
  
  const clearCity = () => {
    setSelectedCity(null);
  };

  return (
    <CityContext.Provider value={{ 
      selectedCity, 
      selectedDistrict, 
      selectedService, 
      handleSaveCity, 
      handleSaveDistrict, 
      handleSaveService, 
      clearDistrict, 
      clearCity 
    }}>
      {children}
    </CityContext.Provider>
  );
}